'use client'

import { type IChatNotificationData } from '@repo/sdk'
import { Button } from '@repo/ui'
import { useRouter } from 'next/navigation'
import React from 'react'

interface IProps {
  data: IChatNotificationData
  type: string
}

export const NotificationChat = ({ data }: IProps) => {
  const router = useRouter()

  return (
    <div
      className={
        'flex w-full max-w-xl flex-col gap-1 rounded-s border-l-4 border-l-gray-200 bg-white px-4 py-2 shadow-md'
      }
    >
      {data.user.name} wrote a message in
      <Button
        className={'h-10'}
        onClick={() => {
          router.push(`/inquiries/${data.load_id}`)
        }}
        variant={'outline'}
      >
        {data.load_id}
      </Button>
    </div>
  )
}
